module.exports = __webpack_public_path__ + "static/img/590.455a711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/590.jpg
// module id = xcbp
// module chunks = 0